import React from 'react';
import Icon from './iconLogo';

function Logo(props) {
  return (
    <Icon {...props}>
      <g>
  	<g>
  		<path class="st0" d="M297.4,117.4h-8.7c-1.5,0-2.6-0.7-3.3-2l-12.6-21.9l-12.7,22c-0.6,1.3-1.8,1.9-3.3,1.9h-8.7
  			c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.5-0.8-1.1-0.8-1.8V66.7c0-0.7,0.3-1.3,0.8-1.8c0.5-0.4,1.1-0.7,1.8-0.7h9.7c0.7,0,1.3,0.2,1.8,0.7
  			c0.5,0.5,0.8,1.1,0.8,1.7v24.7l7.2-12.7c0.8-1.3,1.9-2,3.2-2h4.1c1.2,0,2.3,0.7,3.2,2l7.1,12.7V66.7c0-0.7,0.3-1.3,0.8-1.8
  			c0.5-0.4,1.1-0.7,1.8-0.7h9.7c0.7,0,1.3,0.2,1.8,0.7l0,0c0.5,0.5,0.8,1.1,0.8,1.8v48.1c0,0.7-0.3,1.3-0.8,1.8
  			C298.7,117.1,298.1,117.4,297.4,117.4z M272.8,91.1l13.7,23.7c0.5,0.9,1.2,1.3,2.2,1.3h8.7c0.4,0,0.7-0.1,1-0.4
  			c0.3-0.3,0.4-0.6,0.4-0.9V66.7c0-0.4-0.1-0.7-0.4-0.9l0,0c-0.3-0.2-0.6-0.4-1-0.4h-9.7c-0.4,0-0.7,0.1-1,0.4
  			c-0.3,0.2-0.4,0.5-0.4,0.9V96L277,79.3c-0.6-0.9-1.3-1.4-2.2-1.4h-4.1c-0.9,0-1.6,0.5-2.2,1.4L259.2,96V66.7
  			c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4h-9.7c-0.4,0-0.7,0.1-1,0.4c-0.3,0.2-0.4,0.5-0.4,0.9v48.1c0,0.4,0.1,0.7,0.4,0.9
  			c0.3,0.3,0.6,0.4,1,0.4h8.7c1.1,0,1.8-0.4,2.2-1.3L272.8,91.1z"/>
  	</g>
  	<g>
  		<path class="st0" d="M178.7,117.4h-20.1c-7.7,0-13.7-1.8-18-5.4c-4.3-3.6-6.6-8.8-6.8-15.5c-0.1-1.5-0.1-3.4-0.1-5.7
  			c0-2.3,0-4.3,0.1-5.7c0.5-13.9,8.7-20.9,24.4-20.9h20.5c0.7,0,1.3,0.2,1.8,0.7l0,0c0.5,0.5,0.8,1.1,0.8,1.7v48.1
  			c0,0.7-0.2,1.3-0.7,1.8C180,117.1,179.4,117.4,178.7,117.4z M158.1,65.4c-15.1,0-22.7,6.5-23.2,19.7c-0.1,1.4-0.1,3.3-0.1,5.6
  			c0,2.3,0,4.2,0.1,5.7c0.2,6.3,2.3,11.2,6.4,14.6c4.1,3.4,9.9,5.1,17.2,5.1h20.1c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.4-0.6,0.4-1V66.7
  			c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4H158.1z M166.8,106.2h-7.9c-3.4,0-6-0.8-7.7-2.4c-1.8-1.6-2.7-4.1-2.8-7.4
  			c-0.1-1.4-0.2-3.2-0.2-5.5c0-2.3,0.1-4.2,0.2-5.6c0.1-3.4,1-5.9,2.6-7.5c1.6-1.6,4.2-2.4,7.5-2.4h8.3V106.2z M158.5,76.6
  			c-3,0-5.3,0.7-6.7,2.1c-1.4,1.4-2.2,3.6-2.3,6.7c-0.1,1.4-0.2,3.3-0.2,5.5c0,2.3,0.1,4.1,0.2,5.4c0.1,3,0.9,5.2,2.4,6.6
  			c1.5,1.4,3.9,2.1,6.9,2.1h6.7V76.6H158.5z"/>
  	</g>
  	<g>
  		<path class="st0" d="M123.6,117.4h-21.1c-6.8,0-12.3-1.5-16.2-4.6c-3.9-3.1-5.9-7.4-5.9-13c0-3.6,0.9-6.7,2.6-9.2
  			c1.6-2.3,3.8-4.2,6.5-5.6l-10-17.5c-0.2-0.4-0.3-0.8-0.3-1.1c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,1-0.7,1.6-0.7h10.8
  			c1.7,0,3,0.8,3.7,2.4l8.2,15.7h6.4V66.7c0-0.7,0.3-1.3,0.8-1.8c0.5-0.4,1.1-0.7,1.8-0.7h10.5c0.7,0,1.3,0.2,1.8,0.7l0,0
  			c0.5,0.5,0.8,1.1,0.8,1.7v48.1c0,0.7-0.2,1.3-0.7,1.8C124.9,117.1,124.3,117.4,123.6,117.4z M81.4,65.4c-0.3,0-0.5,0.1-0.7,0.3
  			c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.1,0.1,0.3,0.2,0.5l10.7,18.6l-0.6,0.3c-2.8,1.3-5,3.1-6.6,5.4c-1.6,2.3-2.4,5.2-2.4,8.5
  			c0,5.2,1.8,9.2,5.5,12.1c3.7,2.9,8.9,4.3,15.5,4.3h21.1c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.4-0.6,0.4-1V66.7c0-0.3-0.1-0.6-0.4-0.9
  			c-0.3-0.3-0.6-0.4-0.9-0.4h-10.5c-0.4,0-0.7,0.1-1,0.4c-0.3,0.2-0.4,0.5-0.4,0.9v16.8h-8.3l-8.6-16.4c-0.5-1.2-1.4-1.7-2.6-1.7
  			H81.4z M111.7,106.7h-9.1c-2.3,0-4.2-0.6-5.4-1.9c-1.3-1.3-1.9-2.9-1.9-4.9c0-2,0.6-3.7,1.9-4.9c1.3-1.2,3.1-1.8,5.4-1.8h9.1
  			V106.7z M102.6,94.4c-2,0-3.6,0.5-4.6,1.4c-1,1-1.5,2.3-1.5,4c0,1.7,0.5,3.1,1.5,4.1c1,1,2.6,1.5,4.6,1.5h7.9v-11H102.6z"/>
  	</g>
  	<g>
  		<path class="st0" d="M70.3,117.4h-11c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.5-0.7-1.1-0.7-1.8V66.7c0-0.6,0.2-1.2,0.7-1.7
  			c0.5-0.5,1.1-0.7,1.8-0.7h11c0.7,0,1.3,0.2,1.8,0.7l0,0c0.5,0.5,0.8,1.1,0.8,1.7v48.2c0,0.7-0.3,1.3-0.8,1.8
  			C71.6,117.1,71,117.4,70.3,117.4z M59.4,65.4c-0.4,0-0.7,0.1-0.9,0.4c-0.3,0.3-0.4,0.5-0.4,0.9v48.2c0,0.4,0.1,0.7,0.4,0.9
  			c0.2,0.2,0.6,0.4,1,0.4h11c0.4,0,0.7-0.1,0.9-0.4c0.3-0.2,0.4-0.5,0.4-0.9V66.7c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4
  			H59.4z"/>
  	</g>
  	<g>
  		<path class="st0" d="M45.1,117.4H25c-7.7,0-13.7-1.8-18-5.4c-4.3-3.6-6.6-8.8-6.8-15.5c-0.1-1.5-0.1-3.4-0.1-5.7
  			c0-2.3,0-4.3,0.1-5.7c0.5-13.9,8.7-20.9,24.4-20.9h20.5c0.7,0,1.3,0.2,1.8,0.7l0,0c0.5,0.5,0.8,1.1,0.8,1.7v48.1
  			c0,0.7-0.2,1.3-0.7,1.8C46.5,117.1,45.9,117.4,45.1,117.4z M24.6,65.4c-15.1,0-22.7,6.5-23.2,19.7c-0.1,1.4-0.1,3.3-0.1,5.6
  			c0,2.3,0,4.2,0.1,5.7c0.2,6.3,2.3,11.2,6.4,14.6c4.1,3.4,9.9,5.1,17.2,5.1h20.1c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.4-0.6,0.4-1V66.7
  			c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4H24.6z M33.2,106.2h-7.9c-3.4,0-6-0.8-7.7-2.4c-1.8-1.6-2.7-4.1-2.8-7.4
  			c-0.1-1.4-0.2-3.2-0.2-5.5c0-2.3,0.1-4.2,0.2-5.6c0.1-3.4,1-5.9,2.6-7.5c1.6-1.6,4.2-2.4,7.5-2.4h8.3V106.2z M25,76.6
  			c-3,0-5.3,0.7-6.7,2.1c-1.4,1.4-2.2,3.6-2.3,6.7c-0.1,1.4-0.2,3.3-0.2,5.5c0,2.3,0.1,4.1,0.2,5.4c0.1,3,0.9,5.2,2.4,6.6
  			c1.5,1.4,3.9,2.1,6.9,2.1H32V76.6H25z"/>
  	</g>
  	<g>
  		<g>
  			<path class="st0" d="M0.6,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.4
  				c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v13.9c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1H0.9
  				C0.8,146.9,0.7,146.8,0.6,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M5.9,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4C6,132,6.1,132,6.3,132h0.4
  				c0.2,0,0.3,0.1,0.4,0.3l7.8,12v-11.8c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h0.4c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v13.9c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.1h-0.5c-0.2,0-0.3-0.1-0.4-0.3l-7.8-11.9v11.7
  				c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H6.3C6.1,146.9,6,146.8,5.9,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M23.7,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.1h-4.2c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-0.3
  				c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h9.7c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3
  				c-0.1,0.1-0.2,0.1-0.4,0.1h-4.2v13.1c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.4C23.9,146.9,23.8,146.8,23.7,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M32.3,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h8.3
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7.4v5.4h6.9
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-6.9v5.6h7.6
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-8.5
  				C32.5,146.9,32.4,146.8,32.3,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M44.9,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h5
  				c1.5,0,2.7,0.4,3.6,1.1c0.9,0.7,1.3,1.8,1.3,3.2c0,1.1-0.3,2-0.8,2.7c-0.6,0.7-1.3,1.2-2.4,1.4l3.4,5.8c0,0.1,0.1,0.2,0.1,0.2
  				c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.3c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.4l-3.4-5.7h-4.4v5.8
  				c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.4C45.1,146.9,45,146.8,44.9,146.7z M50.1,139.3c1.2,0,2.2-0.3,2.8-0.8
  				c0.6-0.5,0.9-1.3,0.9-2.3c0-1-0.3-1.8-0.9-2.3c-0.6-0.5-1.5-0.8-2.8-0.8h-4v6H50.1z"/>
  		</g>
  		<g>
  			<path class="st0" d="M57,146.7c-0.1-0.1-0.1-0.2-0.1-0.3l0-0.2l5.4-13.8c0.1-0.3,0.3-0.4,0.6-0.4h0.7c0.3,0,0.5,0.1,0.6,0.4
  				l5.4,13.8l0,0.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4c-0.1,0-0.2,0-0.3-0.1s-0.1-0.1-0.2-0.2l-1.3-3.4h-7.5
  				l-1.3,3.4c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4C57.2,146.9,57.1,146.8,57,146.7z M60,141.9h6.5l-3.3-8.4
  				L60,141.9z"/>
  		</g>
  		<g>
  			<path class="st0" d="M72.8,145.5c-0.9-1-1.4-2.4-1.5-4.2c0-0.4,0-1,0-1.9c0-0.9,0-1.5,0-1.9c0.1-1.8,0.6-3.2,1.5-4.2
  				c0.9-1,2.3-1.6,4.1-1.6c1.3,0,2.3,0.2,3.1,0.7c0.8,0.5,1.5,1,1.9,1.7c0.4,0.7,0.6,1.4,0.7,2.2v0c0,0.1,0,0.2-0.1,0.3
  				c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4c-0.3,0-0.4-0.1-0.5-0.4c-0.3-1.2-0.8-2.1-1.5-2.6c-0.7-0.5-1.7-0.7-2.9-0.7
  				c-1.3,0-2.4,0.4-3.1,1.1c-0.7,0.8-1.1,1.9-1.2,3.5c0,0.4,0,1,0,1.8c0,0.8,0,1.4,0,1.8c0.1,1.6,0.5,2.7,1.2,3.5
  				c0.7,0.8,1.8,1.1,3.1,1.1c1.2,0,2.2-0.2,2.9-0.7c0.7-0.5,1.2-1.3,1.5-2.6c0.1-0.3,0.2-0.4,0.5-0.4h0.4c0.1,0,0.2,0,0.3,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.3c0,0.7-0.3,1.5-0.7,2.2c-0.4,0.7-1,1.3-1.9,1.7c-0.8,0.5-1.9,0.7-3.1,0.7
  				C75.1,147.1,73.7,146.6,72.8,145.5z"/>
  		</g>
  		<g>
  			<path class="st0" d="M89.1,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.1h-4.2c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-0.3
  				c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h9.7c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3
  				c-0.1,0.1-0.2,0.1-0.4,0.1h-4.2v13.1c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.4C89.3,146.9,89.2,146.8,89.1,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M97.7,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.4
  				c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v13.9c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4
  				C97.9,146.9,97.8,146.8,97.7,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M106.7,146.4l-4.9-13.7l0-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.4c0.1,0,0.2,0,0.3,0.1
  				c0.1,0.1,0.1,0.1,0.2,0.2l4.7,13l4.7-13c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1h0.4c0.1,0,0.2,0,0.3,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.3l0,0.2l-4.9,13.7c-0.1,0.3-0.4,0.5-0.7,0.5h-0.6C107.1,146.9,106.8,146.7,106.7,146.4z"/>
  		</g>
  		<g>
  			<path class="st0" d="M116.6,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h8.3
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7.4v5.4h7c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7v5.6h7.6c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H117C116.8,146.9,116.7,146.8,116.6,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M134.7,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1h0.5
  				c0.2,0,0.4,0.1,0.4,0.3l4.8,9.4l4.8-9.4c0.1-0.2,0.2-0.3,0.4-0.3h0.5c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v13.9
  				c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.4c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-11.5l-4.1,8
  				c-0.1,0.3-0.3,0.4-0.7,0.4h-0.5c-0.3,0-0.5-0.1-0.7-0.4l-4.1-8v11.5c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1H135
  				C134.9,146.9,134.8,146.8,134.7,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M151.3,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h8.3
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7.4v5.4h7c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7v5.6h7.6c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-8.5C151.5,146.9,151.4,146.8,151.3,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M163.8,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h4.5
  				c1.5,0,2.6,0.2,3.5,0.6c0.9,0.4,1.5,1.1,1.8,1.9c0.4,0.8,0.6,1.9,0.6,3.2c0,0.4,0,1,0,1.7c0,0.7,0,1.3,0,1.7
  				c0,1.4-0.2,2.5-0.6,3.3s-1,1.4-1.8,1.9c-0.8,0.4-2,0.6-3.4,0.6h-4.6C164,146.9,163.9,146.8,163.8,146.7z M168.7,145.6
  				c1.1,0,2-0.2,2.7-0.5c0.7-0.3,1.1-0.8,1.4-1.4c0.3-0.7,0.4-1.6,0.5-2.7c0-0.4,0-1,0-1.6c0-0.6,0-1.1,0-1.6c0-1.6-0.4-2.7-1.1-3.5
  				c-0.7-0.7-1.9-1.1-3.6-1.1h-3.5v12.3H168.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M178.2,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.4
  				c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v13.9c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4
  				C178.4,146.9,178.3,146.8,178.2,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M182.1,146.7c-0.1-0.1-0.1-0.2-0.1-0.3l0-0.2l5.4-13.8c0.1-0.3,0.3-0.4,0.6-0.4h0.7c0.3,0,0.5,0.1,0.6,0.4
  				l5.4,13.8l0,0.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2l-1.3-3.4
  				h-7.5l-1.3,3.4c0,0.1-0.1,0.1-0.2,0.2s-0.2,0.1-0.3,0.1h-0.4C182.3,146.9,182.2,146.8,182.1,146.7z M185.1,141.9h6.5l-3.3-8.4
  				L185.1,141.9z"/>
  		</g>
  		<g>
  			<path class="st0" d="M202.3,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h4.5
  				c1.5,0,2.6,0.2,3.5,0.6c0.9,0.4,1.5,1.1,1.8,1.9c0.4,0.8,0.6,1.9,0.6,3.2c0,0.4,0,1,0,1.7c0,0.7,0,1.3,0,1.7
  				c0,1.4-0.2,2.5-0.6,3.3c-0.4,0.8-1,1.4-1.8,1.9c-0.8,0.4-2,0.6-3.4,0.6h-4.6C202.5,146.9,202.4,146.8,202.3,146.7z M207.2,145.6
  				c1.1,0,2-0.2,2.7-0.5c0.7-0.3,1.1-0.8,1.4-1.4c0.3-0.7,0.4-1.6,0.5-2.7c0-0.4,0-1,0-1.6c0-0.6,0-1.1,0-1.6c0-1.6-0.4-2.7-1.1-3.5
  				c-0.7-0.7-1.9-1.1-3.6-1.1h-3.5v12.3H207.2z"/>
  		</g>
  		<g>
  			<path class="st0" d="M216.7,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h8.3
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7.4v5.4h7c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7v5.6h7.6c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H217C216.9,146.9,216.8,146.8,216.7,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M230.7,146.5c-0.8-0.4-1.4-0.8-1.9-1.4c-0.4-0.6-0.7-1.2-0.7-1.9c0-0.1,0-0.2,0.1-0.3
  				c0.1-0.1,0.2-0.1,0.3-0.1h0.4c0.3,0,0.4,0.1,0.5,0.4c0.1,0.7,0.5,1.3,1.2,1.8c0.7,0.5,1.7,0.8,2.9,0.8c1.3,0,2.3-0.2,3-0.7
  				c0.7-0.5,1-1.2,1-2.1c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.7-1.4-0.9c-0.6-0.3-1.5-0.6-2.8-1c-1.1-0.4-1.9-0.7-2.6-1
  				c-0.6-0.3-1.1-0.8-1.4-1.3c-0.3-0.5-0.4-1.1-0.4-1.9c0-0.7,0.2-1.4,0.6-2c0.4-0.6,1-1,1.7-1.4c0.7-0.3,1.6-0.5,2.6-0.5
  				c1,0,1.9,0.2,2.7,0.6c0.8,0.4,1.3,0.9,1.7,1.4c0.4,0.6,0.6,1.2,0.6,1.7c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4
  				c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.7-0.5-1.3-1.1-1.8c-0.7-0.5-1.5-0.7-2.5-0.7c-1.1,0-2,0.2-2.6,0.6
  				c-0.6,0.4-1,1.1-1,1.9c0,0.6,0.1,1,0.4,1.4c0.3,0.4,0.7,0.7,1.3,0.9c0.6,0.3,1.4,0.6,2.6,0.9c1.2,0.4,2.1,0.7,2.7,1.1
  				c0.7,0.3,1.1,0.8,1.5,1.2c0.3,0.5,0.5,1.1,0.5,1.9c0,1.3-0.5,2.3-1.4,3c-0.9,0.7-2.3,1.1-3.9,1.1
  				C232.5,147.1,231.5,146.9,230.7,146.5z"/>
  		</g>
  		<g>
  			<path class="st0" d="M242.1,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.4
  				c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v13.9c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.4
  				C242.3,146.9,242.2,146.8,242.1,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M248.3,145.5c-1-1-1.5-2.4-1.6-4.1c0-0.4,0-1.1,0-2c0-0.9,0-1.6,0-2c0.1-1.7,0.6-3.1,1.6-4.1
  				c1-1,2.4-1.5,4.1-1.5c1.2,0,2.2,0.2,3,0.7c0.8,0.5,1.4,1,1.8,1.6c0.4,0.6,0.6,1.2,0.6,1.6v0c0,0.1,0,0.2-0.1,0.3
  				c-0.1,0.1-0.2,0.1-0.3,0.1H257c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.8-0.7-1.4-1.4-1.9
  				c-0.7-0.5-1.6-0.8-2.8-0.8c-1.3,0-2.4,0.4-3.1,1.1c-0.8,0.7-1.2,1.8-1.2,3.4c0,0.4,0,1.1,0,1.9c0,0.8,0,1.5,0,1.9
  				c0.1,1.5,0.5,2.7,1.2,3.4c0.8,0.7,1.8,1.1,3.1,1.1c1.3,0,2.4-0.4,3.2-1.1c0.8-0.8,1.2-1.9,1.2-3.3v-1.1h-3.7
  				c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.4v-0.3c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h4.5c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v1.9c0,1.1-0.2,2.1-0.7,3c-0.5,0.9-1.1,1.5-2,2c-0.9,0.5-1.9,0.7-3.1,0.7
  				C250.7,147.1,249.3,146.6,248.3,145.5z"/>
  		</g>
  		<g>
  			<path class="st0" d="M261.6,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h0.4
  				c0.2,0,0.3,0.1,0.4,0.3l7.8,12v-11.8c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h0.4c0.2,0,0.3,0,0.4,0.1
  				c0.1,0.1,0.1,0.2,0.1,0.4v13.9c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.1H271c-0.2,0-0.3-0.1-0.4-0.3l-7.8-11.9v11.7
  				c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.4C261.8,146.9,261.7,146.8,261.6,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M276.1,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h8.3
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-7.4v5.4h6.9
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-6.9v5.6h7.6
  				c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-8.5
  				C276.3,146.9,276.2,146.8,276.1,146.7z"/>
  		</g>
  		<g>
  			<path class="st0" d="M288.7,146.7c-0.1-0.1-0.1-0.2-0.1-0.3v-13.9c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1h5
  				c1.5,0,2.7,0.4,3.6,1.1c0.9,0.7,1.3,1.8,1.3,3.2c0,1.1-0.3,2-0.8,2.7c-0.6,0.7-1.3,1.2-2.4,1.4l3.4,5.8c0,0.1,0.1,0.2,0.1,0.2
  				c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.3c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.4l-3.4-5.7h-4.4v5.8
  				c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H289C288.9,146.9,288.8,146.8,288.7,146.7z M293.9,139.3c1.2,0,2.2-0.3,2.8-0.8
  				c0.6-0.5,0.9-1.3,0.9-2.3c0-1-0.3-1.8-0.9-2.3c-0.6-0.5-1.5-0.8-2.8-0.8h-4v6H293.9z"/>
  		</g>
  	</g>
  	<g>
  		<g>
  			<path class="st0" d="M219.2,117.9h-11.9c-1.8,0-3-0.9-3.6-2.6L186,66.5c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.6,0.2-1.1,0.7-1.5
  				c0.4-0.4,1-0.7,1.5-0.7h9.9c1.4,0,2.5,0.7,3.1,2l2.6,7h19.1l2.6-7c0.6-1.4,1.7-2.1,3.1-2.1h9.9c0.6,0,1.1,0.2,1.5,0.7
  				c0.4,0.4,0.7,1,0.7,1.5c0,0.4,0,0.7-0.1,0.9l-17.7,48.8C222.2,117,221,117.9,219.2,117.9z M188.1,64.6c-0.2,0-0.5,0.1-0.7,0.3
  				c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0,0.5,0,0.5l17.7,48.8c0.4,1.2,1.2,1.8,2.5,1.8h11.9c1.3,0,2.1-0.6,2.5-1.8l17.7-48.8
  				c0,0,0-0.1,0-0.5c0-0.2-0.1-0.5-0.3-0.7l0,0c-0.2-0.2-0.4-0.3-0.7-0.3h-9.9c-1,0-1.6,0.4-2,1.3l-2.9,7.7h-20.8l-2.9-7.8
  				c-0.4-0.9-1-1.3-2-1.3H188.1z M213.3,105.7l-7.6-21.8h15.2L213.3,105.7z M207.3,85.1l5.9,17l5.9-17H207.3z"/>
  		</g>
  	</g>
  	<g>
  		<path class="st0" d="M5.8,54.2c-3.6-2.7-5.5-6.7-5.7-12c0-0.5,0.2-0.8,0.5-1.2c0.3-0.3,0.7-0.5,1.1-0.5h3.9c1.1,0,1.7,0.6,1.9,1.7
  			c0.3,3.3,1.6,5.7,3.8,7.3c2.2,1.6,5,2.4,8.4,2.4c3.8,0,6.8-1.3,8.9-3.8c2.1-2.5,3.2-5.9,3.2-10.2V10.8H4.6c-0.5,0-0.9-0.2-1.3-0.5
  			C3,10,2.8,9.5,2.8,9V6.2c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.7-0.5,1.3-0.5h32.6c0.6,0,1,0.2,1.3,0.5C38.8,5.2,39,5.7,39,6.2v31.9
  			c0,4.1-0.8,7.6-2.3,10.6c-1.5,3-3.8,5.4-6.7,7.1c-2.9,1.7-6.4,2.5-10.4,2.5C14,58.3,9.5,57,5.8,54.2z"/>
  	</g>
  	<g>
  		<path class="st0" d="M69.3,53c-3.5-3.5-5.3-8.8-5.3-16V6.2c0-0.6,0.2-1,0.5-1.3c0.3-0.3,0.7-0.5,1.2-0.5h3.6c0.6,0,1,0.2,1.3,0.5
  			c0.3,0.3,0.5,0.8,0.5,1.3v31c0,5,1.2,8.7,3.5,11.1c2.3,2.4,5.6,3.6,9.8,3.6c4.2,0,7.5-1.2,9.8-3.7c2.3-2.5,3.5-6.1,3.5-11v-31
  			c0-0.6,0.2-1,0.5-1.3c0.3-0.3,0.7-0.5,1.3-0.5h3.6c0.5,0,0.9,0.2,1.3,0.5c0.3,0.3,0.5,0.8,0.5,1.3v30.8c0,7.1-1.8,12.5-5.3,16
  			c-3.5,3.5-8.5,5.3-15.1,5.3C77.9,58.3,72.9,56.6,69.3,53z"/>
  	</g>
  	<g>
  		<path class="st0" d="M123.7,57.1c-0.3-0.3-0.5-0.7-0.5-1.3V6.2c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.7-0.5,1.2-0.5h3.8
  			c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.3v45h25.4c0.6,0,1,0.2,1.3,0.5c0.3,0.3,0.5,0.7,0.5,1.3v2.9c0,0.5-0.2,0.9-0.5,1.3
  			c-0.4,0.3-0.8,0.5-1.3,0.5h-30.8C124.4,57.6,124,57.4,123.7,57.1z"/>
  	</g>
  	<g>
  		<path class="st0" d="M171.9,57.1c-0.3-0.3-0.5-0.7-0.5-1.3V6.2c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.7-0.5,1.2-0.5h3.8
  			c0.6,0,1,0.2,1.3,0.5c0.3,0.3,0.5,0.7,0.5,1.3v49.6c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.7,0.5-1.3,0.5h-3.8
  			C172.6,57.6,172.2,57.4,171.9,57.1z"/>
  	</g>
  	<g>
  		<path class="st0" d="M192.9,57.1c-0.3-0.3-0.5-0.7-0.5-1.1l0.2-0.8l18.8-49.1c0.4-1.1,1.2-1.7,2.4-1.7h4.9c1.2,0,2,0.6,2.4,1.7
  			L240,55.2l0.2,0.8c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H235c-0.5,0-0.9-0.1-1.3-0.4c-0.3-0.3-0.5-0.6-0.6-0.9
  			l-4.3-10.9h-25.1l-4.2,10.9c-0.4,0.9-1,1.3-1.9,1.3H194C193.6,57.6,193.2,57.4,192.9,57.1z M205.9,39h20.8l-10.4-27.3L205.9,39z"
  			/>
  	</g>
  	<g>
  		<path class="st0" d="M260.1,57.1c-0.3-0.3-0.5-0.7-0.5-1.3V6.2c0-0.6,0.2-1,0.5-1.3c0.3-0.3,0.7-0.5,1.2-0.5h3.3
  			c0.5,0,0.9,0.1,1.1,0.3c0.3,0.2,0.5,0.5,0.8,0.8l25.4,39.2V6.2c0-0.6,0.2-1,0.5-1.3c0.3-0.3,0.7-0.5,1.3-0.5h3.4
  			c0.6,0,1,0.2,1.3,0.5c0.3,0.3,0.5,0.8,0.5,1.3v49.5c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.7,0.5-1.3,0.5h-3.4c-0.9,0-1.5-0.4-1.8-1.1
  			l-25.4-38.8v38.1c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.7,0.5-1.3,0.5h-3.5C260.8,57.6,260.4,57.4,260.1,57.1z"/>
  	</g>
  </g>
    </Icon>
  )
}

export default Logo;



// WEBPACK FOOTER //
// ./src/icons/components/logo.js